import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  className?: string;
  scrollTo?: string;
  href?: string;
}
export function CTAButton({
  text,
  className = '',
  scrollTo,
  href
}: CTAButtonProps) {
  const baseClasses = `inline-block bg-gradient-to-r from-[#F2B705] to-[#E5A800] text-carbon font-bold rounded-xl px-8 py-4 text-center hover:brightness-110 transition-all tracking-wide cursor-pointer ${className}`;
  const animationProps = {
    whileHover: {
      scale: 1.02
    },
    whileTap: {
      scale: 0.98
    },
    animate: {
      boxShadow: ['0px 0px 0px rgba(242,183,5,0)', '0px 0px 15px rgba(242,183,5,0.3)', '0px 0px 0px rgba(242,183,5,0)']
    },
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  };
  if (scrollTo) {
    return <motion.button onClick={() => {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }} className={baseClasses} {...animationProps} data-id="element-63">
        {text}
      </motion.button>;
  }
  return <motion.a href={href || 'https://calendar.app.google/PYPdcRoYne7QrNJA7'} target="_blank" rel="noopener noreferrer" className={baseClasses} {...animationProps} data-id="element-64">
      {text}
    </motion.a>;
}